import React, { Component } from 'react';
import { Collapse } from 'reactstrap';

import moment from 'moment';

import '../../../../../../../student-report/routes/StudentReport/components/StudentReport/components/Header/Header.scss';
import './Header.scss';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      summariesVisible: true
    };

    this.toggleSummaries = this.toggleSummaries.bind(this);
  }

  toggleSummaries(e) {
    e.preventDefault();

    this.setState({
      summariesVisible: !this.state.summariesVisible
    });
  }

  render() {
    let oldSummaries = this.props['student-report-data'].summaries.slice(0, -1);

    return (
      <div className='student-report-header'>
        <div className='student-report-header__logo'>
          <img src='/images/student-report/logo.png' alt='Paragon One Logo' />
        </div>
        <div className='student-report-header__title'>
          <div className='container'>
            {(this.props['student-report-data'].user && this.props['student-report-data'].user.first_name && this.props['student-report-data'].user.last_name) ? <h1>Paragon One Report for {this.props['student-report-data'].user.first_name} {this.props['student-report-data'].user.last_name}</h1> : <h1>Paragon One Report</h1>}
            <br />
          </div>
        </div>
        <div className='student-report-header__summary progress-report-header__summary'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-7'>
                <h3>Program Overview</h3>
                <ul>
                  <li>Total Purchased: {this.props['student-report-data'].credits.total_purchased}</li>
                  <li>Completed: {this.props['student-report-data'].credits.completed}</li>
                  <li>In Progress: {this.props['student-report-data'].credits.in_progress}</li>
                  <li>Forfeited: {this.props['student-report-data'].credits.forfeited}</li>
                </ul>
              </div>
              {(this.props['student-report-data'].top_industries.length > 0) ? (
                <div className='col-md-5'>
                  <h3>Your Career Interests</h3>
                  <ul>
                    {this.props['student-report-data'].top_industries.map((industry, index) =>
                      (<li key={industry.id}><span className='order-number'>{index + 1}</span> {industry.name}</li>)
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
          <br />
          <br />
          <div className="container">
            <div className="row">
              {this.props['student-report-data'].summaries.length > 0 &&
                <div className='col-md-12'>
                  <h3>Summaries from Advisors</h3>
                  {this.props['student-report-data'].summaries.length > 0 && ( // Change to bar design
                    <p className='student-report-header__old-summaries__date oldSummeries__TimeBreak'>{moment(this.props['student-report-data'].summaries.slice(-1)[0].summary_date).format('MMM DD, YYYY')}</p>
                  )}
                  <p>{this.props['student-report-data'].summaries.slice(-1)[0].summary_text}</p>
                </div>
              }
            </div>
          </div>
          {oldSummaries.length > 0 &&
            (
              <div className='student-report-header__old-summaries'>
                <div className='container'>
                  <div className='row'>
                    <div className='col'>
                      <div className='student-report-header__old-summaries__toggle-wrapper'>
                        <a href='#' onClick={this.toggleSummaries} className='text-center'>
                          {this.state.summariesVisible ? 'Hide older feedback ^' : 'Show older feedback'}
                        </a>
                      </div>
                      <Collapse isOpen={this.state.summariesVisible} className='student-report-header__old-summaries__collapse'>
                        {oldSummaries.reduce((Sum, s) => [
                          (
                            <div key={s.id}>
                              <p className='student-report-header__old-summaries__date oldSummeries__TimeBreak'>{moment(s.summary_date).format('MMM DD, YYYY')}</p>
                              <p>{s.summary_text}</p>
                            </div>
                          ),
                          ...Sum,
                        ], [])}
                      </Collapse>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/Header/index.js